<template>
  <div>
    <slot :isLoading="isLoading" :actionMethod="actionMethod" />
  </div>
</template>

<script>
export default {
  name: 'WithLoading',
  props: {
    method: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    actionMethod() {
      this.isLoading = true;
      return this.method().finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
